<template>
    <page-wrapper>
        <page-header>
            <template v-slot:breadcrumbs>
                <q-breadcrumbs-el :label="$t('views.dev.components.components')" :to="{ name: 'dev-components' }" />
                <q-breadcrumbs-el :label="$t('views.dev.components.prototype.prototype')" :to="{ name: 'dev-component-prototype' }" />
            </template>

            <h1>{{ $t('views.dev.components.prototype.prototype') }}</h1>
        </page-header>

        <div class="row q-col-gutter-md">
            <div class="col-xs-12">
                <prototype
                    :state="{
                        contact: {
                            firstName: 'Max',
                            lastName: 'Mustermann'
                        },
                        emails: ['max@mustermann.ch', 'ding@dong.com'],
                        phoneNumbers: null,
                    }"
                    :views="{
                        start: {
                            viewState: { showMessage: false },
                            actions: {
                                showMessage (state, viewState) {
                                    viewState.showMessage = true;
                                }
                            }
                        },
                        configuration: {
                            viewState: { numberOfEmployees: 2 }
                        },
                        end: {}
                    }"
                >
                    <template v-slot:view-start="{ state, viewState, actions, setCurrentView }">
                        <h1>Start</h1>
                        <div>{{ state }}</div>
                        <ul v-if="state.emails.length">
                            <li v-for="email in state.emails" :key="`email-${email}`">{{ email }}</li>
                        </ul>
                        <p><base-button label="Add email" @click="state.emails.push('wicked@sicked.net')" /></p>
                        <div v-if="state.phoneNumbers?.length">We have phoneNumbers!</div>
                        <p><base-button label="Set phoneNumbers" @click="state.phoneNumbers = ['000 987 65 43']" /></p>
                        <div>{{ viewState }}</div>
                        <div v-if="viewState.showMessage">This is a very important message!</div>
                        <p><base-button label="Toggle showMessage" @click="viewState.showMessage = !viewState.showMessage" /></p>
                        <p><base-button label="Call action" @click="actions.showMessage" /></p>
                        <p><base-button label="To the configuration" @click="setCurrentView('configuration')" /></p>
                    </template>
                    <template v-slot:view-configuration="{ state, viewState, actions, setCurrentView }">
                        <h1>Configuration</h1>
                        <div>{{ state }}</div>
                        <div>{{ viewState }}</div>
                        <div v-if="viewState.numberOfEmployees >= 5">Wow, the team is growing big time!</div>
                        <p><base-button label="Hire employee!" @click="viewState.numberOfEmployees++" /></p>
                        <p><base-button label="The end is near" @click="setCurrentView('end')" /></p>
                    </template>
                    <template v-slot:view-end="{ state, viewState, actions, setCurrentView }">
                        <h1>End</h1>
                        <div>{{ state }}</div>
                        <div>{{ viewState }}</div>
                        <p><base-button label="Back to square 1" @click="setCurrentView('start')" /></p>
                    </template>
                </prototype>
            </div>
        </div>
    </page-wrapper>
</template>

<script>
export default {
    name: 'DevComponentPrototype',
    meta () {
        return {
            title: this.$t('views.dev.components.prototype.prototype'),
        }
    },
    components: {},
    data () {
        return {}
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
</style>
